// src/services/empresa/company.service.ts

import type { CompanyData } from '@/types/company.model';
import ApiClient from '../api/axios/apiClient';
import qs from 'qs';

// Get company information
export const getCompanyInfo = async (): Promise<CompanyData> => {
  try {

    const query = qs.stringify(
		{
			populate: ['logo'],
			pagination: {
				page: 1,
				pageSize: 50,
			},
		},
		{
			encodeValuesOnly: true,
		},
	);

    const response = await ApiClient.get(`/empresas?${query}`);

    if(response.status  !== 200 || response.data.data.length === 0){
      throw Error('Empresa no configurada')
    }

    return response.data.data[0];

  } catch (error) {
    console.error('Error fetching company info:', error);
    throw error;
  }
};

// Update company information
export const updateCompanyInfo = async (companyData: CompanyData): Promise<CompanyData> => {
  try {
    // Prepare data for API - ensure null values are handled properly and exclude id/documentId from payload
    const { id, createdAt, updatedAt, documentId, ...dataToSend } = companyData; // Destructure to exclude id, logo and documentId from the payload
    dataToSend.direccion = companyData.direccion || null;
    dataToSend.emailContacto = companyData.emailContacto || null;
    dataToSend.personaContacto = companyData.personaContacto || null;

    // Use the API client like in other services - prioritize documentId if available, fallback to id
    if (!documentId) {
      throw new Error('Company documentId is required for update operation');
    }

    const response = await ApiClient.put(`/empresas/${companyData.documentId}`,
    {
      data: dataToSend
    }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating company info:', error);
    throw error;
  }
};